import { render, staticRenderFns } from "./CompanyInfoOpportunity.vue?vue&type=template&id=9221e1b0&scoped=true"
import script from "./CompanyInfoOpportunity.vue?vue&type=script&lang=js"
export * from "./CompanyInfoOpportunity.vue?vue&type=script&lang=js"
import style0 from "./CompanyInfoOpportunity.vue?vue&type=style&index=0&id=9221e1b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9221e1b0",
  null
  
)

export default component.exports